import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useElementSize } from 'usehooks-ts';
import { interleave } from '../../utils/common';
import { Warranty } from '../warranty';
import { useGetWarrantyDistanceProps, useGetWarrantyDurationProps, useWarrantyLayout } from './warrantyPanel.hooks';
import { WarrantyPanelProps } from './warrantyPanel.types';

const useStyles = makeStyles<{ direction: 'row' | 'column', gap: number }>({ name: 'WarrantiesPanel' })((theme, { direction, gap }) => ({
	root: {
		display: 'flex',
		flexDirection: direction,
		gap,
		alignItems: 'center'
	},
	warranty: {
		flexGrow: 1
	},
	panelCombined: {
		display: 'flex',
		flexDirection: direction,
		gap,
		alignItems: 'center'
	},
	labelOr: {
		fontWeight: 700,
		fontSize: '16px',
		lineHeight: '24px'
	},
	divider: {
		border: '0.5px solid ' + theme.palette.divider,
		borderRight: 'none',
		borderBottom: 'none',
		alignSelf: 'stretch'
	},
	visibilityHidden: {
		visibility: 'hidden'
	},
	displayNone: {
		display: 'none'
	}
}));

export const WarrantyPanel = (props: WarrantyPanelProps) => {
	const { warranties, car, translations } = props;
	const { mileage } = car;

	const [ref, { width }] = useElementSize();
	const { size, direction, gap } = useWarrantyLayout(warranties, width);
	const getWarrantyDurationProps = useGetWarrantyDurationProps(size, translations);
	const getWarrantyDistanceProps = useGetWarrantyDistanceProps(size, translations, mileage);

	const { classes } = useStyles({ direction, gap });

	return (
		<div ref={ref} className={classes.root}>
			{interleave(warranties.map((warranty, index) => {
				if (warranty.product_distance && warranty.product_duration) {
					let propsDistance = getWarrantyDistanceProps(warranty);
					let propsDuration = getWarrantyDurationProps(warranty);
					const classesDistance = { 
						title: direction === 'row' ? classes.visibilityHidden : classes.displayNone,
						linkConditions: direction === 'row' && classes.visibilityHidden
					};
					const classesDuration = { 
						linkConditions: direction === 'column' && classes.displayNone
					};
					return (
						<div key={index} className={classes.panelCombined}>
							<Warranty {...propsDuration} classes={classesDuration}/>
							<span className={classes.labelOr}>Or</span>
							<Warranty {...propsDistance} classes={classesDistance} />
						</div>
					);
				}
				if (warranty.product_distance)
					return <Warranty key={index} {...getWarrantyDistanceProps(warranty)} />;
				if (warranty.product_duration)
					return <Warranty key={index} {...getWarrantyDurationProps(warranty)} />;
				return <div>invalid warranty</div>;
			}), <div className={classes.divider} />)}
		</div>
	);
};
